"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiplePlanningApplication$ = exports.MultiplePlanningApplication$outboundSchema = exports.MultiplePlanningApplication$inboundSchema = void 0;
exports.multiplePlanningApplicationToJSON = multiplePlanningApplicationToJSON;
exports.multiplePlanningApplicationFromJSON = multiplePlanningApplicationFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const planningdatesobject_js_1 = require("./planningdatesobject.js");
/** @internal */
exports.MultiplePlanningApplication$inboundSchema = z.object({
    additional_dates: z.nullable(planningdatesobject_js_1.PlanningDatesObject$inboundSchema),
    address: z.string(),
    appeal_decision: z.nullable(z.string()),
    appeal_status: z.nullable(z.string()),
    council: z.string(),
    decision: z.nullable(z.string()),
    decision_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    description: z.string(),
    distance_in_metres: z.nullable(z.number().int()),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$inboundSchema),
    postcode: z.string(),
    received_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    reference_number: z.string(),
    status: z.string(),
    street_group_property_id: z.nullable(z.string()),
    url: z.string(),
    validated_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "additional_dates": "additionalDates",
        "appeal_decision": "appealDecision",
        "appeal_status": "appealStatus",
        "decision_date": "decisionDate",
        "distance_in_metres": "distanceInMetres",
        "received_date": "receivedDate",
        "reference_number": "referenceNumber",
        "street_group_property_id": "streetGroupPropertyId",
        "validated_date": "validatedDate",
    });
});
/** @internal */
exports.MultiplePlanningApplication$outboundSchema = z.object({
    additionalDates: z.nullable(planningdatesobject_js_1.PlanningDatesObject$outboundSchema),
    address: z.string(),
    appealDecision: z.nullable(z.string()),
    appealStatus: z.nullable(z.string()),
    council: z.string(),
    decision: z.nullable(z.string()),
    decisionDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    description: z.string(),
    distanceInMetres: z.nullable(z.number().int()),
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$outboundSchema),
    postcode: z.string(),
    receivedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    referenceNumber: z.string(),
    status: z.string(),
    streetGroupPropertyId: z.nullable(z.string()),
    url: z.string(),
    validatedDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        additionalDates: "additional_dates",
        appealDecision: "appeal_decision",
        appealStatus: "appeal_status",
        decisionDate: "decision_date",
        distanceInMetres: "distance_in_metres",
        receivedDate: "received_date",
        referenceNumber: "reference_number",
        streetGroupPropertyId: "street_group_property_id",
        validatedDate: "validated_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MultiplePlanningApplication$;
(function (MultiplePlanningApplication$) {
    /** @deprecated use `MultiplePlanningApplication$inboundSchema` instead. */
    MultiplePlanningApplication$.inboundSchema = exports.MultiplePlanningApplication$inboundSchema;
    /** @deprecated use `MultiplePlanningApplication$outboundSchema` instead. */
    MultiplePlanningApplication$.outboundSchema = exports.MultiplePlanningApplication$outboundSchema;
})(MultiplePlanningApplication$ || (exports.MultiplePlanningApplication$ = MultiplePlanningApplication$ = {}));
function multiplePlanningApplicationToJSON(multiplePlanningApplication) {
    return JSON.stringify(exports.MultiplePlanningApplication$outboundSchema.parse(multiplePlanningApplication));
}
function multiplePlanningApplicationFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MultiplePlanningApplication$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MultiplePlanningApplication' from JSON`);
}
//# sourceMappingURL=multipleplanningapplication.js.map